/**
 * This file is provided under the MIT License
 * Copyright (c) 2015 Espen Hovlandsdal
 * https://github.com/andi23rosca/solid-markdown/blob/master/license
 */

export const defaults = {
  remarkPlugins: [],
  rehypePlugins: [],
  class: "",
  unwrapDisallowed: false,
  disallowedElements: undefined,
  allowedElements: undefined,
  allowElement: undefined,
  children: "",
  sourcePos: false,
  rawSourcePos: false,
  skipHtml: false,
  includeElementIndex: false,
  transformLinkUri: null,
  transformImageUri: undefined,
  linkTarget: "_self",
  components: {},
};
